import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Disable CRA's react-error-overlay full-page overlay. Errors still log to
// console — this only prevents the modal that hides the UI for benign warnings
// like "ResizeObserver loop completed with undelivered notifications".
if (process.env.NODE_ENV === "development") {
  try {
    // eslint-disable-next-line global-require
    require("react-error-overlay").stopReportingRuntimeErrors();
  } catch (_) { /* ignore */ }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
